import { OdataItems } from '@/shared/model/odataItems';
import { WebPushMessage } from '@/shared/model/webPushMessage';
import { Component, toNative, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import ExpandableElement from '@/components/_common/expandableElement/expandableElement.vue';
import DateUtils from '@/shared/utils/dateUtils';

const name = 'web-push-messages';
const webPushModule = namespace('webPushModule');

@Component({ name: name, components: { ExpandableElement } })
class WebPushMessagesComponent extends Vue {
  @webPushModule.Action('getMessages')
  private actionGetWebPushMessages!: any;
  @webPushModule.Action('markAllMessagesRead')
  private actionMarkAllWebPushMessagesRead!: any;
  @webPushModule.Mutation('setMessagesPage')
  private mutationSetWebPushMessagesPage!: any;
  @webPushModule.Getter('getMessages')
  private webPushMessages!: OdataItems<WebPushMessage>;
  @webPushModule.Getter('getMessagesPage')
  private webPushMessagesPage!: number;
  @webPushModule.Getter('getMessagesMaxPage')
  private webPushMessagesMaxPage!: number;

  private unreadWebpushMessages: boolean = false;

  private mounted() {
    this.getWebPushMessages();
  }

  private async getWebPushMessages() {
    await this.actionGetWebPushMessages();
    this.unreadWebpushMessages =
      this.webPushMessages.items.find((x) => x.read === false) != undefined;
  }

  private onClickPushMessagesBell() {
    if (this.unreadWebpushMessages) {
      this.actionMarkAllWebPushMessagesRead();
    }
    this.unreadWebpushMessages = false;
  }

  private decreaseWebPushMessagesPage() {
    this.mutationSetWebPushMessagesPage(this.webPushMessagesPage - 1);
    this.actionGetWebPushMessages();
  }

  private increaseWebPushMessagesPage() {
    this.mutationSetWebPushMessagesPage(this.webPushMessagesPage + 1);
    this.actionGetWebPushMessages();
  }

  private getLocalTimeOfMessage(webpushMessage: WebPushMessage) {
    return DateUtils.formatDateTimeWithLocaleAndTimezone(
      webpushMessage.createdDate,
      this.$i18n.locale
    )?.substring(10);
  }

  private getWebPushMessagesAtDate(date: string) {
    return this.webPushMessages.items.filter(
      (x) => x.createdDate.substring(0, 10) === date
    );
  }

  private get dates() {
    const dates: string[] = [];
    for (const webPushMessage of this.webPushMessages.items) {
      if (!dates.includes(webPushMessage.createdDate.substring(0, 10))) {
        dates.push(webPushMessage.createdDate.substring(0, 10));
      }
    }

    return dates;
  }

  private get mobileXs() {
    return this.$vuetify.display.xs;
  }
}
export default toNative(WebPushMessagesComponent);
